import { InputProps, Input, Form } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import { meal_box_quantity_option, meal_box_quantity_selected } from "../imgs";
import { MyColor } from "../config/myStyle";
import { CSSProperties } from "react";

export type MyRadioProps = {
    select?: boolean
    onSelect?(): void
    className?: string
    style?: CSSProperties
    type?: 'point' | 'hook'
}





export const MyRadio = (props: MyRadioProps) => {

    const getContent = () => {
        switch (props.type) {
            case 'hook': {
                return (
                    // 勾号仅表示已选状态，且不加入外层按钮的可访问名称。
                    <span aria-hidden="true"
                        style={{
                            right: 12,
                            color:props.select?MyColor.primary:undefined,
                            fontSize: 20,
                        }}
                    >
                        {props.select ? "✓" : null}
                    </span>
                )
            }
            default: {
                return (<div
                    style={{
                        height: 16,
                        width: 16,
                        borderRadius: '50%',
                        backgroundColor: props.select ? MyColor.red : undefined,
                    }}
                />)
            }
        }
    }

    return (
        <div
            className={`flex flex-col size-[28px] ${props.className}`}
            style={{
                borderRadius: '50%',
                borderWidth: 2,
                borderColor: MyColor.blue,
                justifyContent: 'center',
                alignItems: 'center',
                ...props.style || {},
            }}
            onClick={() => props.onSelect && props.onSelect()}
        >
            {getContent()}
        </div>
    )
}